import { memo } from 'react';

import { Button } from '@air/primitive-button';

import { workspaceAgentConsentDockTitle } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentComposerChrome';

export type WorkspaceAgentComposerCreditsDepletedMessageProps = {
  body: string;
  heading: string;
  headingId?: string;
  onUpgradeClick?: () => void;
  upgradeCtaLabel?: string;
};

export const WorkspaceAgentComposerCreditsDepletedMessage = memo(
  ({
    body,
    heading,
    headingId,
    onUpgradeClick,
    upgradeCtaLabel,
  }: WorkspaceAgentComposerCreditsDepletedMessageProps) => {
    const showUpgradeCta = onUpgradeClick !== undefined && upgradeCtaLabel !== undefined;

    return (
      <div className="flex w-full flex-col items-start gap-2 text-left">
        <h2 className={workspaceAgentConsentDockTitle()} id={headingId}>
          {heading}
        </h2>
        <p className="ads:text-primary text-12 text-gray-12 leading-4">{body}</p>
        {showUpgradeCta ? (
          <div className="flex w-full justify-end">
            <Button
              appearance="filled"
              color="blue"
              data-testid="WORKSPACE_AGENT_COMPOSER_CREDITS_DEPLETED_UPGRADE"
              onClick={onUpgradeClick}
              size="small"
              type="button"
            >
              {upgradeCtaLabel}
            </Button>
          </div>
        ) : null}
      </div>
    );
  },
);

WorkspaceAgentComposerCreditsDepletedMessage.displayName = 'WorkspaceAgentComposerCreditsDepletedMessage';
